const synchronizationRoutes = [
  {
    path: "synchronization",
    name: "Synchronization",
    redirect: {
      name: "List Synchronization"
    },
    component: () =>
      import(
        /* webpackChunkName: "synchronization" */ "../../views/synchronization/Synchronization.vue"
      ),
    children: [
      {
        path: "list",
        name: "List Synchronization",
        component: () =>
          import(
            /* webpackChunkName: "synchronization" */ "../../views/synchronization/SynchronizationList.vue"
          )
      },
      {
        path: "new",
        name: "New Synchronization",
        component: () =>
          import(
            /* webpackChunkName: "synchronization" */ "../../views/synchronization/SynchronizationNew.vue"
          )
      }
    ]
  }
];

export default synchronizationRoutes;
